import React from 'react'
import { IIcon } from './Icon.interface'
import { IconTestIds } from './iconTestIds'

export const PlusIcon = ({ classes }: IIcon) => (
  <svg
    data-testid={IconTestIds.Plus}
    className={classes}
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.86262 8.544H5.75062V5.424H8.63063V3.68H5.75062V0.559999H3.86262V3.68H0.982625V5.424H3.86262V8.544Z"
      fill="currentColor"
    />
  </svg>
)
